import { Route } from '@angular/router';
import { PurchaseOrderListComponent } from './components/purchase-order/purchase-order-list/purchase-order-list.component';
import { PurchaseOrderDetailsComponent } from './components/purchase-order/purchase-order-details/purchase-order-details.component';
import { PurchaseorderDetailsProductsComponentComponent } from './components/purchase-order/purchase-order-details-products/purchase-order-details-products.component';
import { PurchaseorderDetailsLogsComponentComponent } from './components/purchase-order/purchase-order-details-logs/purchase-order-details-logs.component';
import { PurchaseorderDetailsIntegrateLogsComponentComponent } from './components/purchase-order/purchase-order-details-integrate-logs/purchase-order-details-integrate-logs.component';
import { PurchaseOrdersComponent } from './components/purchases-menu/purchases-menu.component';
import { FiscalDashboardComponent } from './components/fiscal-panel/fiscal-panel-dashboard/fiscal-panel-dashboard.component';
import { keycloakGuard } from '@peca/keycloak';

export const routes: Route[] = [
  {
    path: '',
    component: PurchaseOrdersComponent,
  },
  {
    path: 'pedidos-de-compra',
    component: PurchaseOrderListComponent,
    canActivate: [keycloakGuard(['compras-listagem'])],
  },
  {
    path: 'pedidos-de-compra/:id',
    component: PurchaseOrderDetailsComponent,
    children: [
      {
        path: 'logs',
        component: PurchaseorderDetailsLogsComponentComponent,
      },
      {
        path: 'integrate-logs',
        component: PurchaseorderDetailsIntegrateLogsComponentComponent,
      },
      {
        path: 'produtos',
        component: PurchaseorderDetailsProductsComponentComponent,
      },
      {
        path: '',
        redirectTo: 'produtos',
        pathMatch: 'full',
      },
      {
        path: '**',
        redirectTo: 'produtos',
        pathMatch: 'full',
      },
    ],
  },
  {
    path: 'painel-fiscal',
    component: FiscalDashboardComponent,
    canActivate: [keycloakGuard(['compras-painel-fiscal-listagem'])],
  },
];

export const PurchasesModuleLoad = async () => {
  const { PurchasesModule } = await import('./purchases.module');
  return PurchasesModule;
};
